import InfoIcon from 'components/elements/icons/InfoIcon'
import WarningText from 'components/elements/texts/WarningText'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'
import styled from 'styled-components'

/**
 * 注意メッセージ
 */
const WarningMessage: React.FC<WarningMessageProps> = (props) => {
  return (
    <StyledWarningArea marginSideNone={props.marginSideNone}>
      <InfoIcon width="20px" color={CLIENT_SETTINGS.colors.text} />
      <WarningText>{props.message}</WarningText>
    </StyledWarningArea>
  )
}

type WarningMessageProps = {
  message: string
  marginSideNone?: boolean
}

const StyledWarningArea = styled.div<{ marginSideNone?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${(props): string =>
    props.marginSideNone ? '16px 0' : '24px 20px 0'};
  padding: 8px 16px;
  background: var(--color-warning);
  && * {
    margin: 0 4px;
  }
`

export default WarningMessage
